import {defaultFetch, responseType} from "@/scripts/Common/api";
import type {ApiResponse} from "@/scripts/Common/api";
import type {SepaExport, SepaQueryParams} from "./types";
import type {Pagination} from "@/scripts/Common/paginationType";

const fetchSepaDocuments = async (token: string, queryParams: SepaQueryParams, pagination: Pagination)
    : Promise<ApiResponse<SepaExport[]>> => await defaultFetch({
    apiName: 'sepa',
    bearer: token,
    options: {
        query: {
            PageNumber: (pagination.page - 1),
            PageSize: pagination.itemsPerPage,
            Type: queryParams.sepaType,
            TransactionType: queryParams.transactionType,
            DebitType: queryParams.debitType,
            From: queryParams.accountingStartDate,
            To: queryParams.accountingEndDate,
            HasError: queryParams.hasError
        }
    }
});


const ResetSepaDocument = async (apiName: 'sepaSaleReset' | 'sepaWebchargeReset', sepaDocumentId: number, token: string)
    : Promise<ApiResponse<SepaExport>> => await defaultFetch({
    apiName,
    bearer: token,
    options: {
        routeParams: {
            sepaExportId: sepaDocumentId.toString(10)
        }
    }
});


const DownloadSepaDocument = async (sepaDocumentId: number, token: string) => {
    const {
        error,
        response,
    } = await defaultFetch({
        apiName: 'sepaDownload',
        bearer: token,
        options: {
            routeParams: {
                sepaExportId: sepaDocumentId.toString(10)
            },
            headers: {
                'Content-Type': 'application/text',
            }
        },
        resultType: responseType.text
    });

    return {
        error,
        response
    }
}


export {
    fetchSepaDocuments,
    ResetSepaDocument,
    DownloadSepaDocument
}
